import ReactGA from "react-ga";

const AnalyticsEventTracker = (category = "") => {
  const eventTracker = (action = "", label = "") => {
    ReactGA.event({ category, action, label });
  };
  return eventTracker;
};
export default AnalyticsEventTracker;
